module.exports = __webpack_public_path__ + "front/img/p6.94ae7544.png";